export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">关于我们</h2>
        </div>

        <div className="bg-background-50 border border-background-200/60 rounded-2xl p-7 md:p-10">
          <p className="text-sm text-foreground-600 leading-relaxed mb-4">
            <strong className="text-foreground-900">99漫画</strong>是一个专注于免费漫画在线阅读的平台，致力于为漫迷提供
            类似4399漫画网的高品质阅读体验。我们汇聚了海量<strong className="text-foreground-900">韩漫、日漫、国漫</strong>全集大全资源，
            采用流畅的<strong className="text-foreground-900">下拉式阅读</strong>模式，让您无需翻页即可沉浸式畅享漫画世界。
          </p>
          <p className="text-sm text-foreground-600 leading-relaxed mb-4">
            平台坚持永久免费原则，所有漫画作品均可免费阅读，无需充值会员。同时提供智能
            <strong className="text-foreground-900">追更收藏</strong>功能，收藏的漫画一经更新即刻提醒，
            再也不错过任何精彩章节。无论是热血少年、甜蜜恋爱、悬疑推理还是古风仙侠，99漫画都能满足您的阅读需求。
          </p>
          <p className="text-sm text-foreground-600 leading-relaxed">
            我们持续扩充漫画资源库，每日同步更新热门连载，致力于成为漫迷心中最值得信赖的免费漫画阅读平台。
            如果您对平台有任何建议或合作意向，欢迎通过「投稿咨询」模块与我们联系。
          </p>
        </div>
      </div>
    </section>
  );
}